import { useOnboardingMentor } from "../OnboardingMentorProvider";

interface RestartMentorButtonProps {
  from: "profile" | "editor_top_bar";
  branch?: "blank" | "template";
  templateId?: string | null;
  label?: string;
  className?: string;
}

/**
 * Minimal shared affordance to re-open the walkthrough. The provider is
 * responsible for noop-ing this when disabled, so this component never
 * needs to inspect the feature flag itself.
 *
 * Phase 4 ships the primitive; Phase 6 mounts it on the Profile page and
 * (optionally) in the editor top bar.
 */
export function RestartMentorButton({
  from,
  branch,
  templateId,
  label = "Restart walkthrough",
  className,
}: RestartMentorButtonProps) {
  const mentor = useOnboardingMentor();
  if (!mentor.enabled) return null;

  return (
    <button
      type="button"
      onClick={() => mentor.restart({ from, branch, templateId })}
      className={
        className ??
        "inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50"
      }
    >
      {label}
    </button>
  );
}
